import { type FillApplyEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';
import { calculateFillRange } from './utils/fill/calculate-fill-range';

export function fillApplyReducer(
  state: SelectionState,
  event: FillApplyEvent
): ReducerResponse {
  const sourceRange = state.selections[state.selections.length - 1];

  if (!sourceRange) {
    return { next: state, delta: { kind: 'noop' } };
  }

  const fillRange = calculateFillRange(sourceRange, event.cell);

  return {
    next: {
      ...state,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'fillApplied',
      source: event.source,
      sourceRange,
      fillRange
    }
  };
}
